import React from "react";
import { ellipsizePath } from '../../classes/Util.js'
import FollowPane from '../Scrolling/FollowPane.jsx'
import './EditTextFile.css'

class XcodeDiffViewer extends React.Component {
  buildModel() {
    let { fullText, oldString, newString } = this.props;
    if (!fullText || !oldString || !newString) {
      return { found: true, lines: [] }
    }
    const start = fullText.indexOf(oldString);

    if (start === -1) {
      return {
        found: false,
        lines: fullText.split("\n").map((text, i) => ({
          type: "context",
          oldLineNumber: i + 1,
          newLineNumber: i + 1,
          text,
        })),
      };
    }

    const end = start + oldString.length;

    const before = fullText.slice(0, start);
    const after = fullText.slice(end);
    const newFullText = before + newString + after;

    const oldLines = fullText.split("\n");
    const newLines = newFullText.split("\n");

    const oldStartLine = before.split("\n").length;
    const oldRemovedCount = oldString.split("\n").length;
    const newAddedCount = newString.split("\n").length;

    const contextRadius = 6;

    const oldChunkStart = Math.max(1, oldStartLine - contextRadius);
    const oldChunkEnd = Math.min(
      oldLines.length,
      oldStartLine + oldRemovedCount - 1 + contextRadius
    );

    const newChunkStart = Math.max(1, oldStartLine - contextRadius);
    const newChunkEnd = Math.min(
      newLines.length,
      oldStartLine + newAddedCount - 1 + contextRadius
    );

    const lines = [];

    for (let lineNum = oldChunkStart; lineNum < oldStartLine; lineNum++) {
      lines.push({
        type: "context",
        oldLineNumber: lineNum,
        newLineNumber: lineNum,
        text: oldLines[lineNum - 1],
      });
    }

    const removedLines = oldString.split("\n");
    for (let i = 0; i < removedLines.length; i++) {
      lines.push({
        type: "removed",
        oldLineNumber: oldStartLine + i,
        newLineNumber: null,
        text: removedLines[i],
      });
    }

    const addedLines = newString.split("\n");
    for (let i = 0; i < addedLines.length; i++) {
      lines.push({
        type: "added",
        oldLineNumber: null,
        newLineNumber: oldStartLine + i,
        text: addedLines[i],
      });
    }

    const oldTailStart = oldStartLine + oldRemovedCount;
    const newTailStart = oldStartLine + newAddedCount;
    const tailCount = Math.min(
      oldChunkEnd - (oldStartLine + oldRemovedCount - 1),
      newChunkEnd - (oldStartLine + newAddedCount - 1)
    );

    for (let i = 0; i < tailCount; i++) {
      lines.push({
        type: "context",
        oldLineNumber: oldTailStart + i,
        newLineNumber: newTailStart + i,
        text: newLines[newTailStart + i - 1],
      });
    }

    return { found: true, lines };
  }

  getLineStyle(type) {
    const base = {
      display: "grid",
      gridTemplateColumns: "56px 56px 1fr",
      alignItems: "stretch",
      fontFamily:
        'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      fontSize: 13,
      lineHeight: "20px",
      whiteSpace: "pre-wrap",
    };

    if (type === "added") {
      return {
        ...base,
        background: "#1f3a2a",
      };
    }

    if (type === "removed") {
      return {
        ...base,
        background: "#4a2323",
      };
    }

    return {
      ...base,
      background: "transparent",
    };
  }

  renderLine(line, index) {
    const sign =
      line.type === "added" ? "+" : line.type === "removed" ? "−" : " ";

    return (
      <div key={index} style={this.getLineStyle(line.type)}>
        <div
          style={{
            color: "#7f8c98",
            textAlign: "right",
            padding: "0 10px 0 8px",
            borderRight: "1px solid #2c313c",
            userSelect: "none",
          }}
        >
          {line.oldLineNumber || ""}
        </div>

        <div
          style={{
            color: "#7f8c98",
            textAlign: "right",
            padding: "0 10px 0 8px",
            borderRight: "1px solid #2c313c",
            userSelect: "none",
          }}
        >
          {line.newLineNumber || ""}
        </div>

        <div
          style={{
            padding: "0 12px",
            color:
              line.type === "added"
                ? "#c8facc"
                : line.type === "removed"
                ? "#ffcdcd"
                : "#d7dde5",
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: 16,
              color:
                line.type === "added"
                  ? "#7ee787"
                  : line.type === "removed"
                  ? "#ff7b72"
                  : "#6b7280",
            }}
          >
            {sign}
          </span>
          <span>{line.text}</span>
        </div>
      </div>
    );
  }

  render() {
    const { path } = this.props;
    return <div className='editTextFileMain'>
             <div className='editTextFilePath'>
               {ellipsizePath(path, 80)}
             </div>
             <div className='editTextFileWin'>
               {this.renderWindow()}
             </div>
           </div>
  }

  renderWindow() {
    const { path } = this.props;
    const model = this.buildModel();

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 12,
          overflow: "hidden",
          background: "#1e1f24",
          border: "1px solid #2d2f36",
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        }}
      >
        <div
          style={{
            height: 44,
            background:
              "linear-gradient(to bottom, #3a3d45 0%, #2f3239 100%)",
            borderBottom: "1px solid #23262d",
            display: "flex",
            alignItems: "center",
            padding: "0 14px",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", gap: 8 }}>
            <span
              style={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: "#ff5f57",
                display: "inline-block",
              }}
            />
            <span
              style={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: "#febc2e",
                display: "inline-block",
              }}
            />
            <span
              style={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: "#28c840",
                display: "inline-block",
              }}
            />
          </div>

          {path &&<div
            style={{
              color: "#e5e7eb",
              fontSize: 13,
              fontWeight: 600,
              letterSpacing: 0.2,
            }}
          >
            {path.split("/").pop()}
                  </div>}

        </div>

        <div
          style={{
            background: "#16181d",
            borderBottom: "1px solid #262a33",
            padding: "10px 14px",
            color: "#aeb6c2",
            fontSize: 12,
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          }}
        >
          {model.found ? "Diff preview" : "oldString not found in file: " + this.props.oldString}
        </div>

        <FollowPane
          follow={this.props.follow}
          style={{
            overflow: "auto",
            height: "calc(100% - 100px)",
            padding: "10px 0",
          }}
        >
          {model.lines.map((line, index) => this.renderLine(line, index))}
        </FollowPane>
      </div>
    );
  }
}

export { XcodeDiffViewer} 
